import { CIcon } from '~/icons/types'
export const ciPolygon: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M12 1.8 3.2 6.9v10.2l8.8 5.1 8.8-5.1V6.9zm7.8 14.7L12 21l-7.8-4.5v-9L12 3l7.8 4.5z'
    }
  ],
  name: 'polygon',
  type: 'thin'
}
